export default {
  showInfo: false,
  showDebug: false,
  showWarn: true,
  showError: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-lion/es/config/logger-config.js
// module id = 623
// module chunks = 0